import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import NaviBarStore from './store';
import Link from '@src/components/link';
import CultureSwiper from './components/culture-swiper';
import { isArray } from '@src/utils/type-utils';
import cx from 'classnames';
import aos from '@src/utils/aos';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';

/**
 * NaviBar
 * @param store {NaviBarStore}
 * @returns {JSX.Element}
 * @constructor
 */
const NaviBar = ({ store, isSticky }) => {
  store.use();
  aos.reInit();
  const pageLocalesData = getPageLocalesData();
  const navbarData = pageLocalesData.topBar;
  const commonFooterData = pageLocalesData.common_footer;
  const styles = require('./index.less');
  /**
   * 渲染精品游戏
   * @returns {unknown[]|null}
   */
  const renderRecommendGameList = () => {
    if (store.recommendGameList.length === 0) {
      return null;
    }

    return store.recommendGameList.map((item, key) => {
      return (
        <Link className={styles.recommendGameItem} key={key} href={item.websiteLink} target={'_blank'}>
          <div
            className={styles.recommendGameIcon}
            style={{
              backgroundImage: `url(${item.iconUrl})`
            }}
          />
          <div className={styles.recommendGameName}>{item.title}</div>
        </Link>
      );
    });
  };
  /**
   * 渲染链接部分
   * @param linkArr
   * @returns {*|null}
   */
  const renderLink = linkArr => {
    if (!isArray(linkArr)) {
      return null;
    }
    return linkArr.map((item, key) => {
      return (
        <div className={styles.linkItem} data-title={item.title} key={key}>
          <Link className={styles.linkItemContent} href={item.url} target={'_blank'}>
            {item.title}
          </Link>
        </div>
      );
    });
  };

  return (
    <div className={cx(styles.root, styles.menuRoot, store.isActive && styles.rootAct)} {...aos.FADE_IN()} data-aos-once="true">
      <div className={cx(styles.expandNaviBar, store.isExpand && styles.expandNav)} onMouseLeave={store.closeExpandMenu}>
        {/* <div className={cx(styles.expandNaviBar, styles.expandNav)} onMouseLeave={store.closeExpandMenu}> */}
        <div className={styles.naviBarContainer}>
          <div className={styles.containerMask} onMouseOver={store.closeExpandMenu} />
          <div className={cx(styles.containerContent, isSticky && styles.containerContentAct)}>
            <div className={cx(styles.naviBarTop, isSticky && styles.stickAct)}>
              <Link className={cx(styles.blackLogo)} href="https://www.seasungames.com/#/" target={'_blank'} />
            </div>
            <div className={cx(styles.naviBarBottom, isSticky && styles.stickAct)}>
              <div className={cx(styles.columnContainer, styles.barBottomLeft)}>
                {/* 精品游戏 */}
                <div className={cx(styles.column, styles.recommendGameCol)}>
                  <div className={styles.columnTitle}>{navbarData.premium_games}</div>
                  <div className={styles.columnContent}>
                    <div className={styles.expandRecommendGameList}>{renderRecommendGameList()}</div>
                    <div className={styles.expandRecommendGameMoreBtn}>
                      <Link className={styles.expandRecommendGameMoreBtnContent} onClick={store.redirectGames}>
                        {navbarData.more_game}
                      </Link>
                      <div className={styles.arrowIcon_dark} />
                    </div>
                  </div>
                </div>
                {/* 官方工具 */}
                <div className={styles.columnCol}>
                  <div className={styles.columnTitle}>{commonFooterData.official_tool}</div>
                  <div className={styles.columnContent}>{renderLink(store.officialTool)}</div>
                </div>
                {/* 用户服务 */}
                <div className={styles.columnCol}>
                  <div className={styles.columnTitle}>{commonFooterData.customer_service}</div>
                  <div className={styles.columnContent}>{renderLink(store.userService)}</div>
                </div>
                {/* 了解我们 */}
                <div className={styles.columnCol}>
                  <div className={styles.columnTitle}>{commonFooterData.know_us}</div>
                  <div className={styles.columnContent}>{renderLink(store.aboutUs)}</div>
                </div>
                {/* 加入我们 */}
                <div className={styles.columnCol}>
                  <div className={styles.columnTitle}>{commonFooterData.join_us}</div>
                  <div className={styles.columnContent}>{renderLink(store.joinUs)}</div>
                </div>
              </div>
              <div className={cx(styles.barBottomRight, store.whiteNaviBarBottomRightStatus && styles.show)}>
                <CultureSwiper />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(NaviBar, NaviBarStore);
